<template>
  <span>{{ formatCurrency(price) }}</span>
</template>
<script>
import { formatCurrency } from "@/util.js";

export default {
  name: "PriceDisplay",
  methods: {
    formatCurrency,
  },
  props: {
    price: Number,
  },
};
</script>
